<div class="map-container">
    <div class="map-frame">
        <div class="searchbar">
            <ion-searchbar class="custom-searchbar" (ionClear)="clearMarker()" data-cy="nome" type="text" placeholder="Procure por localidade, endereço..." #searchbar>
            </ion-searchbar>
        </div>
        <div id="map" #map>
        </div>
    </div>
</div>